<template>
  <div>
    <v-card color="grey lighten-1" class="mb-12" elevation="0">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" md="4" class="my-2">
            <v-autocomplete
              v-model="trip.route"
              :items="routes"
              dense
              outlined
              :readonly="mode==3"
              item-text="name"
              item-value="id"
              :label="$t('route')"
              persistent-hint
              return-object
              required
              :rules="requiredRules"
              :hint="
                selectedRoute != null
                  ? selectedRoute.stops_count + ' ' + $t('stops')
                  : ''
              "
              @change="routeSelected"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="4" class="my-2">
            <v-dialog
              ref="effective_date"
              :return-value.sync="trip.effective_date"
              v-model="modal"
              :disabled="mode==3"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="trip.effective_date"
                  :label="$t('effective_date')"
                  dense
                  outlined
                  readonly
                  required
                  :rules="requiredRules"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="trip.effective_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">
                  {{$t('cancel')}}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.effective_date.save(trip.effective_date)"
                >
                  {{$t('ok')}}
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <v-text-field
              v-model="trip.repetition_period"
              type="number"
              outlined
              dense
              :readonly="mode==3"
              :label="$t('repeated_every_days')"
              :placeholder="$t('enter_repetition_period')"
              :hint="$t('no_repetition_hint')"
              persistent-hint
              required
              :rules="repeatRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <v-dialog
              ref="first_stop_time"
              :return-value.sync="trip.first_stop_time"
              v-model="modal2"
              :disabled="mode==3"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="trip.first_stop_time"
                  outlined
                  dense
                  :label="$t('arrival_time_first_stop')"
                  readonly
                  required
                  :rules="requiredRules"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="modal2"
                v-model="trip.first_stop_time"
                full-width
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal2 = false">
                  {{$t('cancel')}}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.first_stop_time.save(trip.first_stop_time)"
                >
                  {{$t('ok')}}
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="4" class="my-2 d-flex align-center">
            <div class="pa-3 blue lighten-5 rounded-lg border w-100 d-flex align-center">
              <v-icon color="primary" class="mr-2">mdi-map-clock-outline</v-icon>
              <div class="text-caption primary--text">
                <strong>حساب تلقائي للوقت:</strong> يتم حساب أوقات الوصول بين المحطات تلقائياً من مسار الرحلة على الخريطة.
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="4" class="my-2">
            <v-text-field
              v-model.number="trip.station_wait_minutes"
              type="number"
              outlined
              dense
              :readonly="mode==3"
              label="مدة الانتظار في كل محطة (دقيقة)"
              placeholder="5"
              hint="الافتراضي 5 دقائق لكل محطة"
              persistent-hint
              required
              :rules="[v => (v !== null && v !== '' && v >= 0) || $t('must_be_0_or_greater')]"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4" class="my-2">
            <v-checkbox
              v-model="trip.available_for_subscription"
              :label="$t('available_for_subscription')"
              :disabled="mode==3"
              @change="availableChanged"
              dense
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4" class="my-2">
            <v-checkbox
              v-model="trip.subscription_only"
              :label="$t('subscription_only')"
              :disabled="mode==3"
              @change="subscriptionOnlyChanged"
              dense
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col cols="12" class="my-1">
            <v-expansion-panels flat compact class="border rounded-lg">
              <v-expansion-panel class="grey lighten-4">
                <v-expansion-panel-header class="text-caption grey--text text--darken-2 py-2">
                  <span><v-icon small class="mr-1">mdi-shield-outline</v-icon> إعدادات احتياطية (تُستخدم اختياريًا فقط عند تعذر الوصول للخريطة)</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-2">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="trip.stop_to_stop_avg_time"
                        type="number"
                        outlined
                        dense
                        :readonly="mode==3"
                        label="وقت احتياطي بين المحطات عند تعذر الخريطة (دقائق)"
                        placeholder="15"
                        hint="اختياري — التوقيت الافتراضي عند توقف خدمة الخريطة"
                        persistent-hint
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <v-btn v-if="mode!=3" color="primary" @click="next"> {{$t('continue')}} </v-btn>
  </div>
</template>
<script>
export default {
  props: {
    trip: Object,
    routes: Array,
    mode: Number,
  },
  data() {
    return {
      modal: false,
      modal2: false,
      valid: true,
      requiredRules: [(v) => !!v || this.$t("required")],
      repeatRules: [(v) => /^(0|[1-9]\d*)$/.test(v) || this.$t("must_be_0_or_greater")],
      timeRules: [(v) => /^[1-9][0-9]*$/.test(v) || this.$t("must_be_greater_than_0")],
      selectedRoute: null,
    };
  },
  beforeMount() {
    if (!this.trip.effective_date) {
      this.trip.effective_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
    }
    if (this.trip.station_wait_minutes === undefined || this.trip.station_wait_minutes === null) {
      this.$set(this.trip, "station_wait_minutes", 5);
    }
    if (this.trip.available_for_subscription === undefined || this.trip.available_for_subscription === null) {
      this.$set(this.trip, "available_for_subscription", false);
    } else {
      this.$set(this.trip, "available_for_subscription", !!this.trip.available_for_subscription);
    }
    if (this.trip.subscription_only === undefined || this.trip.subscription_only === null) {
      this.$set(this.trip, "subscription_only", false);
    } else {
      this.$set(this.trip, "subscription_only", !!this.trip.subscription_only);
    }
  },
  methods: {
    next(event) {
      if (this.validate()) this.$emit("next", this.trip);
      else this.$emit("invalid");
    },
    validate() {
      this.valid = false;
      let v = this.$refs.form.validate();
      if (v) {
        this.valid = true;
        return true;
      }
      return false;
    },
    routeSelected(r) {
      this.selectedRoute = r;
    },
    availableChanged(val) {
      if (!val) {
        this.trip.subscription_only = false;
      }
    },
    subscriptionOnlyChanged(val) {
      if (val) {
        this.trip.available_for_subscription = true;
      }
    },
  },
};
</script>
